import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getPersistentPlayerId } from '../../metrics';
import { PlaycastAnalyticsAffiliateHitEvent, sendAnalytics } from '@playcastdotio/Analytics';

export const Affiliate = () => {
  const { affiliate } = useParams();
  const navigate = useNavigate();
  const sentToGa = useRef(false);

  useEffect(() => {
    if (affiliate && navigate && !sentToGa.current) {
      const payload: PlaycastAnalyticsAffiliateHitEvent = {
        name: 'affiliate-hit',
        role: 'host',
        affiliate: affiliate,
        persistentId: getPersistentPlayerId(),
      };

      sendAnalytics(payload);
      sentToGa.current = true;
      navigate('/download');
    }
  }, [affiliate, navigate]);

  return null;
};
